import { useMemo } from 'react';
import {
  useIsMapsClient
} from 'store/features/auth';

export const useStationsPriceReportsAccess = () => {
  const isMapsClient = useIsMapsClient();

  return useMemo(() => ({
    editSettings: !isMapsClient,
    viewPriceRepors: true,
    generatePriceReports: true,
    downloadPriceRepors: true,
    sortingViewPriceReports: true,
    filterViewPriceReports: true,
  }), [isMapsClient]);
};
